import React from 'react';
import { marked } from 'marked';
import './MarkdownRenderer.css';

// Configure marked
marked.setOptions({
  breaks: true,
  gfm: true,
});

const MarkdownRenderer = ({ content }) => {
  if (!content) return null;

  const getMarkdownText = () => {
    try {
      const html = marked.parse(content);
      return { __html: html };
    } catch (error) {
      console.error('Error parsing markdown:', error);
      return { __html: content };
    }
  };

  return (
    <div 
      className="markdown-body"
      dangerouslySetInnerHTML={getMarkdownText()} 
    />
  );
};

export default MarkdownRenderer;
